<div class="col-12 px-0">
  <p class="page-header">Table below shows list of all beneficiaries</p>
</div>
<form [formGroup]="searchRecipient" (ngSubmit)="getRecipients()">
  <div class="row">
    <div class="col-8 col-md-3 form-group">
      <mat-form-field>
        <input matInput placeholder="Search" formControlName="searchText">
      </mat-form-field>
    </div>

    <div class="col-4 col-md-2 form-group">
      <button type="submit" class="btn btn-lg btn-block btn-greengo" npFocusOutClicked>Search</button>
    </div>

    <ng-container *ngIf="registrationService.userRole !== userRoleEnum.ReadOnly">
      <div class="col-6 col-md-2 form-group ml-auto">
        <button type="button" class="btn btn-lg btn-block btn-greengo" (click)="clickSetAsMandateBtn()" npFocusOutClicked>Set as mandate</button>
      </div>

      <div class="col-6 col-md-2 form-group">
        <button type="button" class="btn btn-lg btn-block btn-greengo" (click)="addNewRecipient()">Add new beneficiary</button>
      </div>
    </ng-container>

  </div>
</form>

<ng-container *ngIf="!isLoading">
  <ng-table-pagination
    [rows]="rows"
    [columns]="columns"
    [totalItems]="totalItems"
    [showCheckAll]="false"
    [checkItemEvent]="true"
    (tableChanged)="getRecipients($event)"
    (cellClicked)="getBeneficiaryDetails($event)"
    (checkedItem)="checkedItemChange($event)"
    [showCheckbox]="true"
    [multipleSelectedRow]="false">
  </ng-table-pagination>
</ng-container>


<div class="recepient-form py-3" *ngIf="display">
  <form [formGroup]="recipientInfo">
    <div class="row">
      <h6 class="col-md-4 text-fw-700 details-title">
        Beneficiary detail
      </h6>
    </div>
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <div class="form-group">
          <mat-form-field [ngClass]="{
              'is-invalid': (!recipientNameCtrl.valid || recipientInfo.hasError('numberOfWordBeneficiaryName')) && recipientNameCtrl.touched,
              'is-valid': recipientNameCtrl.valid && !recipientInfo.hasError('numberOfWordBeneficiaryName') && recipientNameCtrl.touched}">
            <input matInput formControlName="recipientName" placeholder="Beneficiary Name" class="no-upscope">
          </mat-form-field>
          <div class="error-message" *ngIf="recipientNameCtrl.hasError('required') && recipientNameCtrl.touched">
            Please input valid information here
          </div>
          <div class="error-message"
            *ngIf="recipientNameCtrl.valid && recipientInfo.hasError('numberOfWordBeneficiaryName') && recipientInfo.get('recipientName').touched">
            Please include first and last names in the Beneficiary name
          </div>
          <div class="error-message" *ngIf="recipientNameCtrl.hasError('maxlength') && recipientNameCtrl.touched">
            Maximum of 255 characters
          </div>
          <div class="error-message"
            *ngIf="recipientInfo.get('recipientName').hasError('pattern') && recipientInfo.get('recipientName').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
                          'is-valid': recipientInfo.get('beneType').valid && recipientInfo.get('beneType').touched,
                          'is-invalid': !recipientInfo.get('beneType').valid && recipientInfo.get('beneType').touched
                        }">
            <mat-select placeholder="Beneficiary Type" formControlName="beneType">
              <mat-option *ngFor="let beneType of beneTypes" [value]="beneType.id">
                <span>{{beneType.name}}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="error-message" *ngIf="!recipientInfo.get('beneType').valid && recipientInfo.get('beneType').touched">
            Please input valid information here
          </div>
        </div>
        <div class="form-group">
            <np-mat-autocomplete-hybrid dataDisplayValue="name" [selectControl]="recipientInfo.get('country')"
              placeholder="Bank Country" [data]="countries"
              inputClass="capitalize-field"
              (selecteOptionChanged)="checkRequiredBeneficiaryDetails(); checkRequiredStateProvince(); checkRule(); checkRequiredPurposeOfPayments()"></np-mat-autocomplete-hybrid>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
                          'is-valid': recipientInfo.get('recipientAddress1').valid && recipientInfo.get('recipientAddress1').touched,
                          'is-invalid': !recipientInfo.get('recipientAddress1').valid && recipientInfo.get('recipientAddress1').touched
                        }">
            <input matInput placeholder="Beneficiary Address 1" formControlName="recipientAddress1">
          </mat-form-field>
          <div class="error-message"
            *ngIf="recipientInfo.get('recipientAddress1').hasError('required') && recipientInfo.get('recipientAddress1').touched">
            Please input information here
          </div>
          <div class="error-message"
            *ngIf="recipientInfo.get('recipientAddress1').hasError('maxlength') && recipientInfo.get('recipientAddress1').touched">
            Maximum of 35 characters
          </div>
          <div class="error-message"
            *ngIf="recipientInfo.get('recipientAddress1').hasError('pattern') && recipientInfo.get('recipientAddress1').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>
        <div class="form-group">
          <mat-form-field [ngClass]="{
                          'is-valid': recipientInfo.get('recipientAddress2').valid && recipientInfo.get('recipientAddress2').touched,
                          'is-invalid': !recipientInfo.get('recipientAddress2').valid && recipientInfo.get('recipientAddress2').touched
                        }">
            <input matInput placeholder="Beneficiary Address 2 (Optional)" formControlName="recipientAddress2">
          </mat-form-field>
          <div class="error-message"
            *ngIf="recipientInfo.get('recipientAddress2').hasError('maxlength') && recipientInfo.get('recipientAddress2').touched">
            Maximum of 35 characters
          </div>
          <div class="error-message"
            *ngIf="recipientInfo.get('recipientAddress2').hasError('pattern') && recipientInfo.get('recipientAddress2').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
              'is-valid': recipientInfo.get('beneCity').valid && recipientInfo.get('beneCity').touched,
              'is-invalid': !recipientInfo.get('beneCity').valid && recipientInfo.get('beneCity').touched
            }">
            <input matInput placeholder="Beneficiary City" formControlName="beneCity" maxlength="60">
          </mat-form-field>
          <div class="error-message" *ngIf="recipientInfo.get('beneCity').hasError('required') && recipientInfo.get('beneCity').touched">
            Please input information here
          </div>
          <div class="error-message"
            *ngIf="recipientInfo.get('beneCity').hasError('maxlength') && recipientInfo.get('beneCity').touched">
            Maximum of 60 characters
          </div>
          <div class="error-message"
            *ngIf="recipientInfo.get('beneCity').hasError('pattern') && recipientInfo.get('beneCity').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
              'is-valid': recipientInfo.get('beneState').valid && recipientInfo.get('beneState').touched,
              'is-invalid': !recipientInfo.get('beneState').valid && recipientInfo.get('beneState').touched
            }">
            <input matInput placeholder="Beneficiary State Or Province" formControlName="beneState" maxlength="50">
          </mat-form-field>
          <div class="error-message" *ngIf="recipientInfo.get('beneState').hasError('required') && recipientInfo.get('beneState').touched">
            Please input information here
          </div>
          <div class="error-message"
            *ngIf="recipientInfo.get('beneState').hasError('maxlength') && recipientInfo.get('beneState').touched">
            Maximum of 50 characters
          </div>
          <div class="error-message"
            *ngIf="recipientInfo.get('beneState').hasError('pattern') && recipientInfo.get('beneState').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
              'is-valid': recipientInfo.get('benePostCode').valid && recipientInfo.get('benePostCode').touched,
              'is-invalid': !recipientInfo.get('benePostCode').valid && recipientInfo.get('benePostCode').touched
            }">
            <input matInput placeholder="Beneficiary Post Code" formControlName="benePostCode" maxlength="12">
          </mat-form-field>
          <div class="error-message"
            *ngIf="recipientInfo.get('benePostCode').hasError('required') && recipientInfo.get('benePostCode').touched">
            Please input information here
          </div>
          <div class="error-message"
            *ngIf="recipientInfo.get('benePostCode').hasError('maxlength') && recipientInfo.get('benePostCode').touched">
            Maximum of 12 characters
          </div>
          <div class="error-message"
            *ngIf="recipientInfo.get('benePostCode').hasError('pattern') && recipientInfo.get('benePostCode').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>

        <div class="form-group">
          <np-mat-autocomplete-hybrid dataDisplayValue="name" [selectControl]="recipientInfo.get('recipientCountry')"
            placeholder="Beneficiary Country" [data]="countries" inputClass="capitalize-field"></np-mat-autocomplete-hybrid>
        </div>

        <div class="form-group">
          <mat-form-field [ngClass]="{
                            'is-valid': recipientInfo.get('beneTaxId').valid && recipientInfo.get('beneTaxId').touched,
                            'is-invalid': !recipientInfo.get('beneTaxId').valid && recipientInfo.get('beneTaxId').touched
                          }">
            <input matInput placeholder="Beneficiary Tax ID" formControlName="beneTaxId">
          </mat-form-field>
          <div class="error-message" *ngIf="recipientInfo.get('beneTaxId').hasError('required') && recipientInfo.get('beneTaxId').touched">
            Please input valid information here
          </div>
          <div class="error-message"
            *ngIf="recipientInfo.get('beneTaxId').hasError('pattern') && recipientInfo.get('beneTaxId').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>
      </div>

      <div class="col-md-4 offset-md-4">
        <div class="form-group">
          <np-mat-autocomplete-hybrid dataDisplayValue="code" [selectControl]="recipientInfo.get('currency')" placeholder="Currency"
            [data]="currencies" inputClass="input-upper-case" (selecteOptionChanged)="checkRequiredBeneficiaryDetails(); checkRule()">
          </np-mat-autocomplete-hybrid>
        </div>
      </div>

      <div class="col-md-4 offset-md-4">
        <div class="form-group">
          <mat-form-field [ngClass]="{
                  'is-invalid': !emailCtrl.valid && emailCtrl.touched,
                  'is-valid': emailCtrl.valid && emailCtrl.touched}">
            <input matInput formControlName="email" type="email" placeholder="Email Address">
          </mat-form-field>
          <div class="error-message" *ngIf="emailCtrl.hasError('email') && emailCtrl.touched">
            Please enter a valid email address
          </div>
          <div class="error-message" *ngIf="emailCtrl.hasError('maxlength') && emailCtrl.touched">
            Maximum of 255 characters
          </div>
        </div>
      </div>
      <div class="col-md-4 offset-md-4">
        <div class="form-group">
          <div>
            Set as mandate?
          </div>
          <mat-radio-group formControlName="mandate" [value]="mandateValue">
            <mat-radio-button value="Yes" (change)="changeMandate($event)">Yes</mat-radio-button>
            <mat-radio-button value="No" (change)="changeMandate($event)">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </form>

  <form [formGroup]="paymentInfo">
    <div class="row">
      <h6 class="col-md-4 text-fw-700 details-title">
        Payment details
      </h6>
    </div>

    <div class="row">
      <ng-container *ngIf="isIBANRequired">
        <div class="col-md-4 offset-md-4">
          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-valid': paymentInfo.get('iban').valid && paymentInfo.get('iban').touched,
              'is-invalid': !paymentInfo.get('iban').valid && paymentInfo.get('iban').touched
            }">
              <input matInput placeholder="IBAN number" formControlName="iban" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="paymentInfo.get('iban').hasError('required') && paymentInfo.get('iban').touched">
              Please input information here
            </div>
            <div class="error-message" *ngIf="(
              paymentInfo.get('iban').hasError('maxlength') ||
              paymentInfo.get('iban').hasError('minlength') ||
              paymentInfo.get('iban').hasError('pattern')
              ) && paymentInfo.get('iban').touched">
              IBAN code must between 15 and 34 characters and must contains both letters and numbers or only contain letter.
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isFasterPayandGBP">
        <div class="col-md-4 offset-md-4">
          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-valid': paymentInfo.get('accountNumber').valid && !paymentInfo.hasError('bankDetailsError') && paymentInfo.get('accountNumber').touched,
              'is-invalid': (!paymentInfo.get('accountNumber').valid && paymentInfo.get('accountNumber').touched) ||
              (!paymentInfo.get('accountNumber').value && paymentInfo.get('sortCode').value && !paymentInfo.get('iban').value
              && paymentInfo.get('accountNumber').touched && paymentInfo.get('sortCode').touched) ||
              (paymentInfo.hasError('bankDetailsError') && paymentInfo.get('accountNumber').touched && paymentInfo.get('sortCode').touched && paymentInfo.get('iban').touched)
            }">
              <input matInput placeholder="Account number" formControlName="accountNumber" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="paymentInfo.get('accountNumber').hasError('pattern') && paymentInfo.get('accountNumber').touched">
              Account number must be 8 numbers.
            </div>
          </div>
        </div>

        <div class="col-md-4 offset-md-4">
          <div class="form-group">
              <mat-form-field [ngClass]="{
                'is-valid': paymentInfo.get('sortCode').valid && !paymentInfo.hasError('bankDetailsError') && paymentInfo.get('sortCode').touched,
                'is-invalid': (!paymentInfo.get('sortCode').valid && paymentInfo.get('sortCode').touched) ||
                  (!paymentInfo.get('sortCode').value && paymentInfo.get('accountNumber').value && !paymentInfo.get('iban').value
                  && paymentInfo.get('accountNumber').touched && paymentInfo.get('sortCode').touched) ||
                  (paymentInfo.hasError('bankDetailsError') && paymentInfo.get('accountNumber').touched && paymentInfo.get('sortCode').touched && paymentInfo.get('iban').touched)
              }">
              <input matInput placeholder="Sort code" [formControl]="paymentInfo.controls['sortCode']" npInputMask [options]="{
                  delimiter: '-',
                  blocks: [2, 2, 2]
                }" (keypress)="$event.charCode >= 48 && $event.charCode <= 57" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="paymentInfo.get('sortCode').hasError('pattern') && paymentInfo.get('sortCode').touched">
              Sort code must be 6 characters and contain only numeric
            </div>
          </div>
        </div>

        <div class="col-md-4 offset-md-4">
          <div class="form-group">
            or
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
                    'is-valid': paymentInfo.get('iban').valid && paymentInfo.get('iban').touched,
                    'is-invalid': (!paymentInfo.get('iban').valid || paymentInfo.hasError('bankDetailsError')) && paymentInfo.get('iban').touched
                  }">
              <input matInput placeholder="IBAN number" formControlName="iban" class="no-upscope" />
            </mat-form-field>
            <div class="error-message" *ngIf="(
                                                    paymentInfo.get('iban').hasError('maxlength') ||
                                                    paymentInfo.get('iban').hasError('minlength') ||
                                                    paymentInfo.get('iban').hasError('pattern')
                                                    ) && paymentInfo.get('iban').touched">
              IBAN code must between 15 and 34 characters and must contains both letters and numbers or only contain letter.
            </div>
            <div class="error-message" *ngIf="paymentInfo.hasError('bankDetailsError')
                                          && paymentInfo.get('sortCode').touched
                                          && paymentInfo.get('accountNumber').touched
                                          && paymentInfo.get('iban').touched">
              Please input Account Number and Sort Code or IBAN
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isBankCodeAndAccountMandatory">
        <div class="col-md-4 offset-md-4">
          <div class="form-group">
            <mat-form-field [ngClass]="{
                                      'is-valid': paymentInfo.get('accountNumber').valid && paymentInfo.get('accountNumber').value && paymentInfo.get('accountNumber').touched,
                                      'is-invalid': (!paymentInfo.get('accountNumber').valid || !paymentInfo.get('accountNumber').value) && paymentInfo.get('accountNumber').touched
                                    }">
              <input matInput placeholder="Account number" formControlName="accountNumber" class="no-upscope" />
            </mat-form-field>
            <div class="error-message"
              *ngIf="!paymentInfo.get('accountNumber').value && paymentInfo.get('accountNumber').touched">
              Please input information here
            </div>
            <div class="error-message"
              *ngIf="paymentInfo.get('accountNumber').hasError('pattern') && paymentInfo.get('accountNumber').touched">
              <ng-container *ngIf="isFasterPay">
                Account number must be 8 numbers.
              </ng-container>
              <ng-container *ngIf="!isFasterPay">
                Account number is required and can only include characters and numbers.
              </ng-container>
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
                                      'is-valid': paymentInfo.get('bankCode').valid && paymentInfo.get('bankCode').value && paymentInfo.get('bankCode').touched,
                                      'is-invalid': (!paymentInfo.get('bankCode').valid || !paymentInfo.get('bankCode').value) && paymentInfo.get('bankCode').touched
                                          }">
              <input matInput placeholder="Bank code" formControlName="bankCode" class="no-upscope" />
            </mat-form-field>
            <div class="error-message" *ngIf="
                                    !paymentInfo.get('bankCode').value &&
                                    paymentInfo.get('bankCode').touched
                                  ">
              Please input information here
            </div>

            <div class="error-message" *ngIf="
                                        paymentInfo.get('bankCode').hasError('pattern') &&
                                        !isBankCode9Digits &&
                                        paymentInfo.get('bankCode').touched
                                      ">
              Bank code must be number and characters, no special characters
            </div>
            <div class="error-message" *ngIf="
                                                  paymentInfo.get('bankCode').hasError('pattern') &&
                                                  isBankCode9Digits &&
                                                  paymentInfo.get('bankCode').touched
                                                ">
              Bank code must be 9 digits
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isFasterPayandGBP && !isIBANRequired && !isBankCodeAndAccountMandatory">
        <div class="col-md-4 offset-md-4">
          <div class="form-group">
            <mat-form-field [ngClass]="{
                      'is-valid': paymentInfo.get('accountNumber').valid && paymentInfo.get('accountNumber').touched,
                      'is-invalid': !paymentInfo.get('accountNumber').valid && paymentInfo.get('accountNumber').touched
                    }">
              <input matInput placeholder="Account number" formControlName="accountNumber" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="paymentInfo.get('accountNumber').hasError('required') && paymentInfo.get('accountNumber').touched">
              Please input information here
            </div>
            <div class="error-message" *ngIf="paymentInfo.get('accountNumber').hasError('pattern') && paymentInfo.get('accountNumber').touched">
              <ng-container *ngIf="isFasterPay">
                Account number must be 8 numbers.
              </ng-container>
              <ng-container *ngIf="!isFasterPay">
                Account number is required and can only include characters and numbers.
              </ng-container>
            </div>
          </div>
        </div>
          <div class="col-md-4 offset-md-4">
            <div class="row form-group justify-content-between align-items-center">
              <div class="col-5 pr-0">
                <mat-form-field [ngClass]="{
                          'is-valid': paymentInfo.get('bankCode').valid && (paymentInfo.get('bankCode').value  || paymentInfo.get('swiftCode').value) && paymentInfo.get('bankCode').touched && paymentInfo.get('swiftCode').touched,
                          'is-invalid': !paymentInfo.get('bankCode').valid || (!paymentInfo.get('bankCode').value && !paymentInfo.get('swiftCode').value) && paymentInfo.get('bankCode').touched && paymentInfo.get('swiftCode').touched
                              }">
                  <input matInput placeholder="Bank code" formControlName="bankCode" class="no-upscope"/>
                </mat-form-field>
              </div>
              <div>or</div>
              <div class="col-5 pl-0">
                <mat-form-field [ngClass]="{
                          'is-valid': paymentInfo.get('swiftCode').valid && (paymentInfo.get('bankCode').value  || paymentInfo.get('swiftCode').value) && paymentInfo.get('bankCode').touched && paymentInfo.get('swiftCode').touched,
                          'is-invalid': !paymentInfo.get('swiftCode').valid || paymentInfo.hasError('swiftCodeError') || (!paymentInfo.get('bankCode').value && !paymentInfo.get('swiftCode').value) && paymentInfo.get('bankCode').touched && paymentInfo.get('swiftCode').touched
                              }">
                  <input matInput placeholder="SWIFT code" formControlName="swiftCode" />
                </mat-form-field>
              </div>
              <div class="col-12 error-message" *ngIf="!paymentInfo.get('swiftCode').value && paymentInfo.get('swiftCode').touched && !paymentInfo.get('bankCode').value && paymentInfo.get('bankCode').touched">
                Please input bank code or SWIFT code
              </div>
              <div class="col-12 error-message" *ngIf="
                                              (paymentInfo.hasError('swiftCodeError') ||
                                              paymentInfo.get('swiftCode').hasError('pattern')) &&
                                              paymentInfo.get('swiftCode').touched
                                            ">
                SWIFT code must be 8 or 11 letters. SWIFT code must contain both number and letter or only contain letter
              </div>
              <div class="col-12 error-message" *ngIf="
                        paymentInfo.get('bankCode').hasError('pattern') &&
                        paymentInfo.get('bankCode').touched
                      ">
                Bank code must be number and characters, no special characters
              </div>
            </div>
          </div>
      </ng-container>

      <div class="col-md-4 offset-md-4" *ngIf="!validationOk">
          <div class="row col-6">
            <button class="btn btn-lg btn-block" [ngClass]="{
              'btn-greengo': paymentInfo.valid,
              'btn-inactive': !paymentInfo.valid
            }" (click)="validate(); clickedContinueBtn = true" npFocusOutClicked>Continue</button>
          </div>
          <div class="row">
            <p class="col-12 mt-3">Once the information entered has been validated successfully, beneficiaries bank details will be
              automatically filled below.</p>
          </div>
      </div>
    </div>
  </form>

  <form [formGroup]="bankInfo">
    <div class="row">
      <h6 class="col-md-4 text-fw-700 details-title">
        Bank detail
      </h6>
    </div>

    <div class="row">
      <div class="col-md-4 offset-md-2 col-sm-12">
        <div class="form-group">
          <mat-form-field [ngClass]="{
        'is-invalid': !bankNameCtrl.valid && bankNameCtrl.touched,
        'is-valid': bankNameCtrl.valid && bankNameCtrl.touched}">
            <input matInput formControlName="bankName" placeholder="Bank Name" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="bankNameCtrl.hasError('required') && bankNameCtrl.touched">
            Please input valid information here
          </div>
          <div class="error-message" *ngIf="bankNameCtrl.hasError('maxlength') && bankNameCtrl.touched">
            Maximum of 11 characters
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-12">
        <div class="form-group">
          <mat-form-field [ngClass]="{
        'is-invalid': !address1Ctrl.valid && address1Ctrl.touched,
        'is-valid': address1Ctrl.valid && address1Ctrl.touched}">
            <input matInput formControlName="address1" placeholder="Address 1" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="address1Ctrl.hasError('required') && address1Ctrl.touched">
            Please input valid information here
          </div>
          <div class="error-message" *ngIf="address1Ctrl.hasError('maxlength') && address1Ctrl.touched">
            Maximum of 255 characters
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 offset-md-2 col-sm-12">
        <div class="form-group">
          <mat-form-field [ngClass]="{
            'is-invalid': !address2Ctrl.valid && address2Ctrl.touched,
            'is-valid': address2Ctrl.valid && address2Ctrl.touched}">
            <input matInput formControlName="address2" placeholder="Address 2" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="address2Ctrl.hasError('maxlength') && address2Ctrl.touched">
            Maximum of 255 characters
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-12">
        <div class="form-group">
          <mat-form-field [ngClass]="{
        'is-invalid': !address3Ctrl.valid && address3Ctrl.touched,
        'is-valid': address3Ctrl.valid && address3Ctrl.touched}">
            <input matInput formControlName="address3" placeholder="Address 3" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="address3Ctrl.hasError('maxlength') && address3Ctrl.touched">
            Maximum of 255 characters
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 offset-md-2 col-sm-12">
        <div class="form-group">
          <mat-form-field [ngClass]="{
            'is-invalid': !cityCtrl.valid && cityCtrl.touched,
            'is-valid': cityCtrl.valid && cityCtrl.touched}">
            <input matInput formControlName="city" placeholder="City" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="cityCtrl.hasError('required') && cityCtrl.touched">
            Please input valid information here
          </div>
          <div class="error-message" *ngIf="cityCtrl.hasError('maxlength') && cityCtrl.touched">
            Maximum of 50 characters
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-12">
        <div class="form-group">
          <mat-form-field [ngClass]="{
          'is-invalid': !stateCtrl.valid && stateCtrl.touched,
          'is-valid': stateCtrl.valid && stateCtrl.touched}">
            <input matInput formControlName="state" placeholder="State/Province" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="stateCtrl.hasError('required') &&  stateCtrl.touched">
            Please input valid information here
          </div>
          <div class="error-message" *ngIf="stateCtrl.hasError('maxlength') && stateCtrl.touched">
            Maximum of 100 characters
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 offset-md-2 col-sm-12">
        <div class="form-group">
          <mat-form-field [ngClass]="{
            'is-invalid': !zipCodeCtrl.valid && zipCodeCtrl.touched,
            'is-valid': zipCodeCtrl.valid && zipCodeCtrl.touched}">
            <input matInput formControlName="zipCode" placeholder="Zip/Postal Code" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="zipCodeCtrl.hasError('required') && zipCodeCtrl.touched">
            Please input valid information here
          </div>
          <div class="error-message" *ngIf="zipCodeCtrl.hasError('maxlength') && zipCodeCtrl.touched">
            Maximum of 20 characters
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-12">
        <div class="form-group">
          <mat-form-field>
            <mat-select formControlName="bankCountry" placeholder="Country" disabled>
              <mat-select-trigger>
                <ng-container *ngIf="!bankCountryCtrl.value; else showCountryBank">
                  -----
                </ng-container>
                <ng-template #showCountryBank>
                  <div [innerHTML]="bankCountryCtrl.value | transformCountry : countries"></div>
                </ng-template>
              </mat-select-trigger>
              <mat-option *ngFor="let bankCountry of countries" [value]="bankCountry.id">
                <span class="bankCountry.flag"></span>&nbsp;
                <span>{{bankCountry.name}}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 offset-md-2 col-sm-12">
        <div class="form-group">
          <mat-form-field [ngClass]="{
                        'is-invalid': !referenceCtrl.valid && referenceCtrl.touched,
                        'is-valid': referenceCtrl.valid && referenceCtrl.touched}">
            <input matInput formControlName="reference" maxlength="70" placeholder="Reference">
          </mat-form-field>
          <div class="error-message" *ngIf="referenceCtrl.hasError('maxlength') && referenceCtrl.touched">
            Maximum of 70 characters
          </div>
          <div class="error-message"
            *ngIf="referenceCtrl.hasError('pattern') && referenceCtrl.touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>
      </div>

    <div class="col-md-4 col-sm-12">
      <div class="form-group">
        <mat-form-field [ngClass]="{
            'is-valid': bankInfo.get('bankAccountType').valid && bankInfo.get('bankAccountType').touched,
            'is-invalid': !bankInfo.get('bankAccountType').valid && bankInfo.get('bankAccountType').touched
          }">
          <mat-select placeholder="Bank Account Type" formControlName="bankAccountType">
            <mat-option [value]="null">None</mat-option>
            <mat-option *ngFor="let item of bankAccountTypes" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="error-message"
          *ngIf="!bankInfo.get('bankAccountType').valid && bankInfo.get('bankAccountType').touched">
          Please input information here
        </div>
      </div>
    </div>
    </div>

    <div class="row">
      <div class="col-md-4 offset-md-2 col-sm-12">
        <ng-container *ngIf="purposeOfPayments.length > 0">
          <div class="form-group">
            <mat-form-field
              [ngClass]="{'is-valid': purposeofPaymentSelected && purposeOfPaymentCtrl.valid && purposeOfPaymentCtrl.touched,
                          'is-invalid': (!purposeofPaymentSelected || !purposeOfPaymentCtrl.valid) && purposeOfPaymentCtrl.touched}"
              matTooltip="{{ purposeofPaymentSelected ? purposeOfPaymentCtrl.value : null}}" [matTooltipPosition]="'left'"
              matTooltipClass="custom-mat-tooltip">
              <input type="text" formControlName="purposeOfPayment" matInput [matAutocomplete]="auto"
                placeholder="Purpose of payment">
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPurposeOfPayment($event.option.value)">
                <mat-option *ngFor="let pp of purposeOfPaymentsPipe | async" [value]="pp.id"
                  matTooltip="{{ pp.code }} - {{ pp.description }}" matTooltipClass="custom-mat-tooltip"
                  [matTooltipPosition]="'below'">
                  {{ pp.code }} - {{ pp.description }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div class="error-message" *ngIf="!purposeofPaymentSelected && purposeOfPaymentCtrl.touched">
              Please input valid information here
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </form>

  <div class="row mb-3" *ngIf="registrationService.userRole !== userRoleEnum.ReadOnly">
    <div class="col-6 col-md-2 offset-md-4">
      <button class="btn btn-lg btn-block" (click)="updateRecipient()" type="button" [ngClass]="{
            'btn-greengo': recipientInfo.valid && paymentInfo.valid && bankInfo.valid && validationOk,
            'btn-inactive': !recipientInfo.valid || !paymentInfo.valid || !bankInfo.valid || !validationOk
          }" npFocusOutClicked>Save</button>
    </div>
    <div class="col-6 col-md-2">
      <button class=" btn btn-lead btn-lg btn-block" type="button" (click)="deleteRecipient()">Delete</button>
    </div>
  </div>
</div>
